import { apiSlice } from "../apiSlice";

export const menuApliSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    orderMenu: builder.mutation({
      query: (parameters) => ({
        url: "/orderModules",
        method: "POST",
        body: parameters,
      }),
    }),
    getUserTemporal: builder.query({
      query: (parameters) => ({
        url: `/getUserTemporal/${parameters.USRIDXXX}`,
      }),
    }),
    getPermissionUserReplace: builder.query({
      query: (parameters) => ({
        url: `/getPermissionUserReplace/${parameters.USRIDXXX}`,
      }),
    }),
    getDevices: builder.query({
      query: (parameters) => ({
        url: `/getDevices/${parameters.USRIDXXX}`,
      }),
    }),
    inactivateToken: builder.mutation({
      query: (parameters) => ({
        url: `/inactivateToken/${parameters.id}`,
        method: "delete",
      }),
    }),
  }),
});
export const {
  useOrderMenuMutation,
  useGetUserTemporalQuery,
  useLazyGetPermissionUserReplaceQuery,
  useGetDevicesQuery,
  useLazyGetDevicesQuery,
  useInactivateTokenMutation,
} = menuApliSlice;
